import { render, staticRenderFns } from "./BrandAddress.vue?vue&type=template&id=44b6fa1c&"
import script from "./BrandAddress.vue?vue&type=script&lang=js&"
export * from "./BrandAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports